module.exports = __webpack_public_path__ + "img/appointment-card.54c60f6f.png";